import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

/**
 * Delete orchid pro invoicing series
 *
 */
export default async function deleteInvoicingSeries(
  appointmentSeriesId,
  firstIdToDelete,
) {
  const res = await fetchOrchidAPI(
    `/api/scheduler/invoicing/delete_series/${appointmentSeriesId}`,
    {
      body: JSON.stringify({
        delete_from_appointment_id: firstIdToDelete,
      }),
      method: "DELETE",
    },
  );
  if (!res.ok) {
    throw new Error(
      `failed to delete invoicing series: ${getErrorDetail(await res.text())}`,
    );
  }
  return;
}
